export default function scrollToClass(className: string) {
  if (!document) return
  const element = document.getElementsByClassName(className)[0]
  if (!element) return console.log('cannot find class ' + className)

  element.scrollIntoView({
    behavior: 'smooth'
  })
}